import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Crown, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register, googleLogin, user } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/account"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) navigate("/account");
    else setError(res.error);
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center px-4 py-12">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(230,0,92,0.12),transparent_60%)]" />
      <div className="relative w-full max-w-md glass-strong rounded-2xl p-8" data-testid="register-form">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2"><Crown className="h-7 w-7 text-gold" /><span className="font-serif text-lg text-amber-50">Miss United States of Africa</span></Link>
        <h1 className="text-center text-3xl text-amber-50">Join the movement</h1>
        <p className="mb-6 mt-1 text-center text-sm text-amber-100/60">Create your free fan account.</p>

        <button onClick={googleLogin} data-testid="google-register" className="mb-5 flex w-full items-center justify-center gap-2 rounded-full border border-gold/30 bg-white px-4 py-3 text-sm font-medium text-obsidian hover:bg-white/90">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4" /> Continue with Google
        </button>
        <div className="mb-5 flex items-center gap-3 text-xs text-muted-foreground"><span className="h-px flex-1 bg-gold/15" /> or <span className="h-px flex-1 bg-gold/15" /></div>

        {error && <p className="mb-4 rounded-lg bg-destructive/15 px-4 py-2.5 text-sm text-red-300" data-testid="register-error">{error}</p>}
        <form onSubmit={submit} className="space-y-4">
          <input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" className="w-full rounded-lg border border-gold/25 bg-obsidian px-4 py-3 text-sm text-amber-50 outline-none focus:border-gold" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className="w-full rounded-lg border border-gold/25 bg-obsidian px-4 py-3 text-sm text-amber-50 outline-none focus:border-gold" />
          <input required type="password" minLength={6} placeholder="Password (min 6 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className="w-full rounded-lg border border-gold/25 bg-obsidian px-4 py-3 text-sm text-amber-50 outline-none focus:border-gold" />
          <button disabled={loading} data-testid="register-submit" className="btn-gold flex w-full items-center justify-center gap-2">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Create Account</button>
        </form>
        <p className="mt-5 text-center text-sm text-amber-100/60">Already have an account? <Link to="/login" className="text-gold hover:underline">Sign in</Link></p>
      </div>
    </div>
  );
}
